import clsx from 'clsx';

import { BASE, XS } from '@/types/utils/sizesType';

import type { SocialProfileType } from '@/types/socialProfileType';

import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    TWITTER,
    YOUTUBE
} from '@/lib/socialProfile';

// Components
import { DefaultAvatar } from '@/components/base/Avatar';
// Libs
import { iconSize } from '@/components/base/Avatar/avatarConfig';
import Icon from '@/components/base/Icon';
import Instagram from '@/components/icons/Instagram';
// Types
import { PinterestIcon } from '@/components/icons/Networks/PinterestIcon';
import { YoutubeIcon } from '@/components/icons/Networks/YoutubeIcon';

type SocialProfileMiniDisplayProps = {
    socialProfile: SocialProfileType;
    smaller?: boolean;
    isExport?: boolean;
    className?: string;
};

const SocialProfileIcon = ({ postProfileType, isExport }) => {
    switch (postProfileType) {
        case INSTAGRAM:
            return <Instagram forceLightMode={isExport} />;
        case PINTEREST:
            return <PinterestIcon forceLightMode={isExport} />;
        case YOUTUBE:
            return <YoutubeIcon forceLightMode={isExport} />;
        default:
            return (
                <Icon
                    icon={postProfileType}
                    className={clsx(`!leading-3 ${iconSize[BASE]}`, {
                        'dark:text-white': !isExport,
                        'text-facebook': postProfileType === FACEBOOK,
                        'text-linkedin': postProfileType === LINKEDIN,
                        'text-twitter': postProfileType === TWITTER,
                        'text-tiktok': postProfileType === TIKTOK_BUSINESS
                    })}
                />
            );
    }
};

const SocialProfileMiniDisplay = ({
    socialProfile,
    isExport = false,
    className
}: SocialProfileMiniDisplayProps) => {
    const postProfileType = socialProfile?.social_network_type;

    return (
        <div
            className={clsx(
                'flex items-center justify-center space-x-0.5 rounded-l-full rounded-r-[3000px] bg-white p-[1.25px]',
                { 'dark:bg-icoDarkMode-anthracite': !isExport },
                className
            )}
            title={socialProfile?.slug ?? ''}>
            <DefaultAvatar
                forceLightMode={isExport}
                url={socialProfile?.external_api_data?.avatar}
                fallback={socialProfile?.slug?.[0]}
                profileType={null}
                size={XS}
            />

            <div className="flex max-h-[20px] items-center overflow-visible">
                <SocialProfileIcon postProfileType={postProfileType} isExport={isExport} />
            </div>
        </div>
    );
};

export default SocialProfileMiniDisplay;
